import React, { Component } from 'react'
import {Link} from 'react-router-dom'
class EventBoxs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataEvents: [
                {
                    id: 1,
                    srcimg: 'images/imagebox/001.jpg',
                    title: 'DORADZTWO PODATKOWE',
                    description: 'Doradztwo podatkowe to kompleksowe usługi obejmujące wszystkie aspekty działalności gospodarczej.', 
                },
                {
                    id: 2,
                    srcimg: 'images/imagebox/002.jpg',
                    title: 'USŁUGI KSIĘGOWE',
                    description: 'Oferujemy prowadzenie ksiąg rachunkowych, podatkowych i innych ewidencji',
                },
                {
                    id: 3,
                    srcimg: 'images/imagebox/003.jpg',
                    title: 'OUTSOURCING',
                    description: 'Powierzenie nam obsługi kadrowo-płacowej zapewnia poufność informacji dotyczącej warunków zatrudnienia oraz wynagrodzeń w ramach Państwa przedsiębiorstwa',
                },
            ]
        }
    }
    
    render() {
        return (
            <div className="row">
                {
                    this.state.dataEvents.map(data => (
                        <div className="col-md-4" key={data.id}>
                            <div className="imagebox-item">
                                <div className="imagebox style1">
                                    <div className="imagebox-image">
                                        <img src={data.srcimg} alt="financial" />
                                    </div>
                                    {/* <!-- /.imagebox-image --> */}
                                    
                                    <div className="imagebox-title">
                                        <h3><Link to="/services-v2" onClick={() => {window.location.href="/services-v2"}} title="">{data.title}</Link></h3>
                                    </div>
                                    {/* <!-- /.iamgebox-title --> */}
                                    <div className="imagebox-content">
                                        <div className="imagebox-desc">{data.description}</div>
                                        <div className="imagebox-button">
                                            <Link to="/services-v2" onClick={() => {window.location.href="/services-v2"}} title="">read more</Link>
                                        </div>
                                    </div>
                                    {/* <!-- /.imagebox-content --> */}
                                </div>
                                {/* <!-- /.imagebox --> */}
                            </div>
                            {/* <!-- /.imagebox-item --> */}
                        </div>
                    ))
                }
            </div>
        );
    }
}

export default EventBoxs;